export default __webpack_public_path__ + "static/media/Borealis.78e26469.mp3";